import React from "react";
import LikePlayer from "../../../../assets/icon/LikePlayer";

interface Props {}

const Like: React.FC<Props> = () => {
  return (
    <>
      <div className="pr-2">
        <LikePlayer />
      </div>
    </>
  );
};

export default Like;
